// Shared UI primitives — extracted from App.js (Feb 2026 refactor).
// Behavior-preserving 1:1 copy. Do not add or remove styles.

import React from "react";
import { Loader2 } from "lucide-react";

// ---------------- Button ----------------
export const Button = ({
  children,
  variant = "primary",
  size = "default",
  disabled,
  loading,
  className = "",
  ...props
}) => {
  const variants = {
    primary: "bg-terra text-white hover:bg-terra-dark",
    secondary: "bg-cream-200 text-sand-800 hover:bg-cream-300 border border-[#2A2A2A]",
    ghost: "bg-transparent text-sand-700 hover:bg-cream-200 hover:text-terra-dark",
    destructive: "bg-red-700 text-sand-800 hover:bg-red-800",
  };

  const sizes = {
    small: "px-3 py-1.5 text-sm",
    default: "px-4 py-2",
    large: "px-6 py-3 text-lg",
  };

  return (
    <button
      className={`${variants[variant]} ${sizes[size]} rounded-lg font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <Loader2 className="w-4 h-4 animate-spin" />}
      {children}
    </button>
  );
};

// ---------------- Card ----------------
export const Card = ({ children, className = "", hover = false, ...props }) => {
  return (
    <div
      className={`bg-cream-100 border border-[#2A2A2A] rounded-xl p-6 ${hover ? "card-hover cursor-pointer" : ""} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

// ---------------- ProgressRing ----------------
export const ProgressRing = ({ pct = 0, size = 80, stroke = 8 }) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.max(0, Math.min(100, pct)) / 100) * circumference;
  return (
    <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#EDE5DB"
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#E07A5F"
          strokeWidth={stroke}
          strokeLinecap="round"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.7s ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="font-display text-xl text-sand-800 leading-none">
          {Math.round(pct)}%
        </span>
      </div>
    </div>
  );
};
